<template>
    <div class="content">
        <div id="print">
            <title>打印退货单</title>
            <div style=" position: relative;z-index: 1;margin-top: 50px;">
                <div id="qrcode" style="bottom:0; right: 0;width: 90px;height: 90px;position: absolute;z-index: 3;">
                </div>
                <h1 style=" text-align: center;margin-bottom: 20px !important;margin-top: 20px;font-weight: bold;font-size: 26px">退货单</h1>
                <div style="color: #666;font-size: 13px;margin-top: 40px;margin-bottom: 20px">退货单号：
                    <span style="color: #d9534f;margin-right: 30px">{{refundCode}}</span>退货人：
                    <span style="color: #d9534f;margin-right: 30px">{{from_name}}</span>退货时间：<span
                        style="color: #d9534f;margin-right: 30px">{{created_at}}</span></div>
            </div>
            <div>
                <table width="100%" cellpadding="0" cellspacing="0" border="0" style=" border-collapse: collapse;">
                    <thead>
                    <tr>
                        <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">产品编号</th>
                        <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">产品名称</th>
                        <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">规格</th>
                        <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">数量</th>
                        <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">包装类型</th>
                    </tr>

                    </thead>
                    <tbody>
                    <tr v-for="item in tableData">
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{item.product_sn}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{item.product_name}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{item.production_specs}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{item.real_return_goods_num}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{item.production_unit}}</td>
                    </tr>
                    <tr>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">备注</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;" colspan="4"></td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div style="position: absolute;-webkit-transform: translateX(-50%);-moz-transform: translateX(-50%);-ms-transform: translateX(-50%);-o-transform: translateX(-50%);
        transform: translateX(-50%);left:50%;margin-top: 20px">
            <el-button size="mini" @click="myPrint()">打印</el-button>
            <el-button size="mini" @click="close()">关闭</el-button>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "print-refund",
        data() {
            return {
                refundCode:'',//退货单号
                from_name:'',
                created_at:'',
                tableData:[],
            }
        },
        methods: {
            getData(){
                let url = '/returngoods/' + this.$route.query.return_goods_sn
                this.$get('logistics',url, {
                    returngoods:this.$route.query.return_goods_sn,
                    lang:''
                }).then(res => {
                    console.log(res);
                    this.refundCode = this.$route.query.return_goods_sn;
                    this.from_name = res.data.from_name;
                    this.created_at = res.data.created_at;
                    this.tableData = res.data.return_goods;

                }).catch(function (error) {
                    console.log(error);
                });
            },
            //打印
            myPrint() {
                let obj = document.getElementById('print');
                var newWindow = window.open("打印窗口", "_blank");
                var docStr = obj.innerHTML;
                newWindow.document.write(docStr);
                newWindow.document.close();
                newWindow.print();
                newWindow.close();
            },
            //返回上一页
            close(){
                this.$router.push({
                    name:'refundManage'
                });
            },
            //二维码
            //扫码
            qrcode () {
                //document.getElementById("qrcode").innerHTML = "";
                let url = 'www.baidu.com';
                let qrcode = new QRCode('qrcode', {
                    width: 90,
                    height: 90, // 高度
                    text:  url// 二维码内容
                })
            },
        },
        created() {

            this.getData();
            this.$nextTick(function () {
                this.stock_out_sn = this.$route.query.return_goods_sn;
                this.qrcode();
            });

        },
    }
</script>

<style lang="scss" scoped>
    .container {
        padding: 20px;
        position: relative;

    }
</style>